module.exports = __webpack_public_path__ + "fonts/SFUIDisplay-Heavy.cbfbd9d7.eot";